import breadcrumb from "#templates/pages/breadcrumb";
import language from "#scripts/translation";
// import { getRealestates, getMessages } from './getdata';
// import '#components/mypageheader.js';
import "#components/index.js";

export const minsidePage = (obj) => {
  document.title = language("NAV_MYPAGE");
  sessionStorage.setItem(
    "breadcrumbs",
    `
    <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
    <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("NAV_MYPAGE")}</li>`,
  );
  const breadcrumbHtml = breadcrumb();

  const userName = localStorage.getItem("access_pid");
  const userSSN = localStorage.getItem("access_pid");
  const showVisma = window.serverdata.configMeta.aim?.mysite?.visma?.enabled || false;
  // set content and footer background to pagecolor ( style="background-color:${obj.pageColor};" )
  document.getElementById("maincontent").style.backgroundColor = obj.pageColor;
  document.getElementById("footer").style.backgroundColor = obj.pageColor;
  document.getElementById("warnings_container").style.backgroundColor = obj.pageColor;

  const messagesEnabled = window.serverdata.configMeta.aim?.mysite?.messages?.enabled;
  const realestateEnabled = window.serverdata.configMeta.aim?.mysite?.realestate?.enabled;
  const servicesEnabled = window.serverdata.configMeta.aim?.mysite?.services?.enabled;
  const nationalServicesEnabled = window.serverdata.configMeta.aim?.mysite?.nationalServices?.enabled;
  const invoiceEnabled = window.serverdata.configMeta.aim?.mysite?.invoice?.enabled;
  const invoiceType = window.serverdata.configMeta.aim?.mysite?.invoice?.visma ? "visma" : "KS";
  const formsEnabled = window.serverdata.configMeta.aim?.mysite?.forms?.enabled;

  return `
    <section class="container p-md-0">
      ${breadcrumbHtml}
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
        <div class="row m-0">
          <mypage-header>
            <mypage-title title='${language("NAV_MYPAGE")}'/></mypage-title>
            <!--mypage-profile name='${userName}' editText='${language("MYPAGE_EDITPROFILE")}' logoutText='${language("MYPAGE_LOGOUT")}'/></mypage-profile-->
          </mypage-header>
        </div>
      </div>
    </section>
    <mypage-menu>
      <mypage-menuitem visible=${messagesEnabled} href='?page=post' icon='mail' title='${language("MYPAGE_MENU_POST_TITLE")}' text='${language("MYPAGE_MENU_POST_DESC")}' pagecolor='${obj.pageColor}'></mypage-menuitem>
      <mypage-menuitem visible=${realestateEnabled}  href='?page=eiendom' icon='home' title='${language("MYPAGE_MENU_REALESTATE_TITLE")}' text='${language("MYPAGE_MENU_REALESTATE_DESC")}'></mypage-menuitem>
      <!--mypage-menuitem href='?page=skjema' icon='article' title='${language("MYPAGE_MENU_FORMS_TITLE")}' text='${language("MYPAGE_MENU_FORMS_DESC")}'></mypage-menuitem-->
      <mypage-menuitem visible=${servicesEnabled}  href='?page=tjenester' icon='network_node' title='${language("MYPAGE_MENU_SERVICES_TITLE")}' text='${language("MYPAGE_MENU_SERVICES_DESC")}'></mypage-menuitem>
      <!--mypage-menuitem href='?page=skatt-avgift' icon='universal_currency_alt' title='${language("MYPAGE_MENU_TAX_TITLE")}' text='${language("MYPAGE_MENU_TAX_DESC")}'></mypage-menuitem-->
      <mypage-menuitem visible=${nationalServicesEnabled}  href='?page=nasjonale-tjenester' icon='hub' title='${language("MYPAGE_MENU_GLOBALSERVICES_TITLE")}' text='${language("MYPAGE_MENU_GLOBALSERVICES_DESC")}'>
      </mypage-menuitem>
      <mypage-menuitem visible=${invoiceEnabled} type=${invoiceType} href='?page=faktura' icon='receipt_long' title='${language("MYPAGE_MENU_INVOICE_TITLE")}' text='${language("MYPAGE_MENU_INVOICE_DESC")}'></mypage-menuitem>
      <mypage-menuitem visible=${formsEnabled} href='?page=forms' icon='receipt_long' title='${language("MYPAGE_MENU_FORMS_TITLE")}' text='${language("MYPAGE_MENU_FORMS_DESC")}'></mypage-menuitem>
    </mypage-menu>
    `;
};

export const postPage = (obj) => {
  document.title = language("NAV_MYPAGE");
  sessionStorage.setItem(
    "breadcrumbs",
    `
    <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
    <li class="aim-breadcrumb-item"><a href="?page=">${language("NAV_MYPAGE")}</a></li>
    <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("MYPAGE_POST_PAGE_TITLE")}</li>`,
  );

  const breadcrumbHtml = breadcrumb();

  document.getElementById("maincontent").style.backgroundColor = obj.pageColor;
  document.getElementById("footer").style.backgroundColor = obj.pageColor;
  document.getElementById("warnings_container").style.backgroundColor = obj.pageColor;

  const userSSN = window.serverdata.configMeta.aim?.staticSSN || localStorage.getItem("access_pid");

  return `
    <section class="container p-md-0">
      ${breadcrumbHtml}
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 kommunentainer">
        <div class="row m-0">
          <mypage-header>
            <mypage-title title='${language("MYPAGE_POST_PAGE_TITLE")}' description='${language("MYPAGE_POST_PAGE_DESCRIPTION")}' />
          </mypage-header>
        </div>
      </div>
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
          <div class="row m-0">
          <mypage-messages>
            <mypage-messages-filter></mypage-messages-filter>
            <mypage-messages-list ssn='${userSSN}'></mypage-messages-list>
          </mypage-messages>
          </div>
      </div>
    </section>
  `;
};

export const eiendomPage = (obj) => {
  document.title = language("NAV_MYPAGE");
  sessionStorage.setItem(
    "breadcrumbs",
    `
    <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
    <li class="aim-breadcrumb-item"><a href="?page=">${language("NAV_MYPAGE")}</a></li>
    <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("MYPAGE_REALESTATE_PAGE_TITLE")}</li>`,
  );

  const breadcrumbHtml = breadcrumb();

  document.getElementById("maincontent").style.backgroundColor = obj.pageColor;
  document.getElementById("footer").style.backgroundColor = obj.pageColor;
  document.getElementById("warnings_container").style.backgroundColor = obj.pageColor;

  const userSSN = window.serverdata.configMeta.aim?.staticSSN || localStorage.getItem("access_pid");

  return `
    <section class="container p-md-0">
      ${breadcrumbHtml}
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
        <div class="row m-0">
          <mypage-header>
            <mypage-title title='${language("MYPAGE_REALESTATE_PAGE_TITLE")}' description='${language("MYPAGE_REALESTATE_PAGE_DESCRIPTION")}' />
          </mypage-header>
        </div>
      </div>
    </section>
    <mypage-realestate-list ssn='${userSSN}'></mypage-realestate-list>
  `;
};

export const fakturaPage = (obj) => {
  document.title = language("NAV_MYPAGE");
  sessionStorage.setItem(
    "breadcrumbs",
    `
    <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
    <li class="aim-breadcrumb-item"><a href="?page=">${language("NAV_MYPAGE")}</a></li>
    <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("MYPAGE_INVOICE_PAGE_TITLE")}</li>`,
  );

  const breadcrumbHtml = breadcrumb();
  document.getElementById("maincontent").style.backgroundColor = obj.pageColor;
  document.getElementById("footer").style.backgroundColor = obj.pageColor;
  document.getElementById("warnings_container").style.backgroundColor = obj.pageColor;

  const userSSN = window.serverdata.configMeta.aim?.staticSSN || localStorage.getItem("access_pid");

  return `
    <section class="container p-md-0">
      ${breadcrumbHtml}
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
        <div class="row m-0">
          <mypage-header>
            <mypage-title title='${language("MYPAGE_INVOICE_PAGE_TITLE")}' description='${language("MYPAGE_INVOICE_PAGE_DESCRIPTION")}' />
          </mypage-header>
        </div>
      </div>
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
          <div class="row m-0">
          <mypage-invoices>
            <mypage-invoices-filter></mypage-invoices-filter>
            <mypage-invoices-list ssn='${userSSN}'></mypage-invoices-list>
          </mypage-invoices>
          </div>
      </div>
    </section>
  `;
};

export const formsPage = (obj) => {
  document.title = language("NAV_MYPAGE");
  sessionStorage.setItem(
    "breadcrumbs",
    `
    <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
    <li class="aim-breadcrumb-item"><a href="?page=">${language("NAV_MYPAGE")}</a></li>
    <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("MYPAGE_FORMS_PAGE_TITLE")}</li>`,
  );

  const breadcrumbHtml = breadcrumb();
  document.getElementById("maincontent").style.backgroundColor = obj.pageColor;
  document.getElementById("footer").style.backgroundColor = obj.pageColor;
  document.getElementById("warnings_container").style.backgroundColor = obj.pageColor;

  const userSSN = window.serverdata.configMeta.aim?.staticSSN || localStorage.getItem("access_pid");

  return `
    <section class="container p-md-0">
      ${breadcrumbHtml}
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
        <div class="row m-0">
          <mypage-header>
            <mypage-title title='${language("MYPAGE_FORMS_PAGE_TITLE")}' description='${language("MYPAGE_FORMS_PAGE_DESCRIPTION")}' />
          </mypage-header>
        </div>
      </div>
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
          <div class="row m-0">
          <mypage-forms>
            <mypage-forms-list listtype="saved" ssn='${userSSN}'></mypage-forms-list>
            
            <!--mypage-forms-list listtype="all" ssn='${userSSN}'></mypage-forms-list-->
          </mypage-forms>
          </div>
      </div>
    </section>
  `;
};

export const servicesPage = (obj) => {
  document.title = language("NAV_MYPAGE");
  sessionStorage.setItem(
    "breadcrumbs",
    `
    <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
    <li class="aim-breadcrumb-item"><a href="?page=">${language("NAV_MYPAGE")}</a></li>
    <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("MYPAGE_SERVICES_PAGE_TITLE")}</li>`,
  );

  const breadcrumbHtml = breadcrumb();

  document.getElementById("maincontent").style.backgroundColor = obj.pageColor;
  document.getElementById("footer").style.backgroundColor = obj.pageColor;
  document.getElementById("warnings_container").style.backgroundColor = obj.pageColor;

  return `
    <section class="container p-md-0">
      ${breadcrumbHtml}
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
        <div class="row m-0">
          <mypage-header>
            <mypage-title title='${language("MYPAGE_SERVICES_PAGE_TITLE")}' description='${language("MYPAGE_SERVICES_PAGE_DESCRIPTION")}' />
          </mypage-header>
        </div>
      </div>
    </section>
    <mypage-services-list></mypage-services-list>
  `;
};

export const nationalServicesPage = (obj) => {
  document.title = language("NAV_MYPAGE");
  sessionStorage.setItem(
    "breadcrumbs",
    `
    <li class="aim-breadcrumb-item"><a href="/">${language("NAV_FRONTPAGE")}</a></li>
    <li class="aim-breadcrumb-item"><a href="?page=">${language("NAV_MYPAGE")}</a></li>
    <li class="aim-breadcrumb-item active" aria-current="page" id="currentPageBreadcrumb">${language("MYPAGE_GLOBALSERVICES_PAGE_TITLE")}</li>`,
  );

  const breadcrumbHtml = breadcrumb();

  document.getElementById("maincontent").style.backgroundColor = obj.pageColor;
  document.getElementById("footer").style.backgroundColor = obj.pageColor;
  document.getElementById("warnings_container").style.backgroundColor = obj.pageColor;

  return `
    <section class="container p-md-0">
      ${breadcrumbHtml}
    </section>
    <section class="p-md-0">
      <div class="container p-md-0 minside__container">
        <div class="row m-0">
          <mypage-header>
            <mypage-title title='${language("MYPAGE_GLOBALSERVICES_PAGE_TITLE")}' description='${language("MYPAGE_GLOBALSERVICES_PAGE_DESCRIPTION")}' />
          </mypage-header>
        </div>
      </div>
    </section>
    <mypage-menu cols="3">
      <mypage-menuitem title='Folkeregisteret' type='external-services' href='https://www.skatteetaten.no/person/folkeregister/' aria-label="Folkeregisteret (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/skatteetaten-logo.png' pagecolor='${obj.pageColor}'></mypage-menuitem>
      <mypage-menuitem title='Meld flytting' type='external-services' href='https://www.skatteetaten.no/person/folkeregister/flytte/i-norge/' ria-label="Meld flytting (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/skatteetaten-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='Kontaktregister' type='external-services' href='https://www.digdir.no/felleslosninger/kontaktregisteret/865' ria-label="Kontaktregister (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/difi-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='Adresseendring' type='external-services' href='http://www.posten.no/adresseendring/auth/login.html' ria-label="Adresseendring (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/posten-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='Vegvesen' type='external-services' href='https://www.vegvesen.no/dinside/oversikt' ria-label="Vegvesen (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/vegvesen-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='Digipost' type='external-services' href='https://www.digipost.no/postkasse' ria-label="Digipost (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/digipost-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='eBoks' type='external-services' href='https://www.e-boks.no/privat/#/' ria-label="eBoks (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/e-boks-logo.png' pagecolor='${obj.pageColor}'></mypage-menuitem>
      <mypage-menuitem title='Startlån' type='external-services' href='https://startlan.husbanken.no/#/' ria-label="Startlån (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/husbanken-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='Bostøtte' type='external-services' href='https://kundeforhold-bostotte.husbanken.no/esoknad-bostotte/#/soknad' ria-label="Bostøtte (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/husbanken-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='Min helse' type='external-services' href='https://minhelse.helsenorge.no/innbox' ria-label="Min helse (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/helsenorge-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='Altinn' type='external-services' href='https://www.altinn.no/ui/messagebox/' ria-label="Altinn (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/altinn-logo.png' ></mypage-menuitem>
      <mypage-menuitem title='NAV' type='external-services' href='https://tjenester.nav.no/dittnav/innlogget/' ria-label="NAV (${language("NAV_OPEN_I_NEW")})" target="_blank" icon='/images/minside/nav-logo.png' ></mypage-menuitem>
    </mypage-menu>
  `;
};
